import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import RemoveSubtemplateEditing from './removesubtemplateediting';

export default class RemoveSubtemplate extends Plugin {
  static get pluginName() {
    return "RemoveSubtemplate";
  }

  static get requires() {
    return [RemoveSubtemplateEditing];
  }
}